import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { getDeliveredAtDateFromIAContext } from "../../utils/getDeliveredAtDateFromIAContext";
import { orderCanBeReportedBasedOnDeliveryDate } from "../../utils/orderCanBeReportedBasedOnDeliveryDate";
import { DO_NOT_PROCESS_DAMAGED_AS_RETURN, INELIGIBLE_FOR_REPORT, NEED_MORE_INFO_ANSWER, getReportItemsOrRequestExtensionCTA } from "./shared";
export var ReportDamagedItemIA = function ReportDamagedItemIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getReportItemsOrRequ;
        return (_getReportItemsOrRequ = getReportItemsOrRequestExtensionCTA(context, strictLocalize)) === null || _getReportItemsOrRequ === void 0 ? void 0 : _getReportItemsOrRequ.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getReportItemsOrRequ2, _getReportItemsOrRequ3;
        return (_getReportItemsOrRequ2 = getReportItemsOrRequestExtensionCTA(context, strictLocalize)) === null || _getReportItemsOrRequ2 === void 0 ? void 0 : (_getReportItemsOrRequ3 = _getReportItemsOrRequ2.getLink) === null || _getReportItemsOrRequ3 === void 0 ? void 0 : _getReportItemsOrRequ3.call(_getReportItemsOrRequ2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  var deliveredAt = getDeliveredAtDateFromIAContext(context);
  if (!brandOrder || !shippingContext || !deliveredAt) {
    return NEED_MORE_INFO_ANSWER(strictLocalize);
  }
  return orderCanBeReportedBasedOnDeliveryDate(deliveredAt) ? DAMAGE_ITEM_REPORT_ELIGIBLE(strictLocalize) : DAMAGE_ITEM_REPORT_INELIGIBLE(strictLocalize);
};
var DAMAGE_ITEM_REPORT_ELIGIBLE = function DAMAGE_ITEM_REPORT_ELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return REPORT_DAMAGED(strictLocalize);
    },
    getDescription: function getDescription() {
      return [USE_BUTTON_TO_REPORT_DAMAGE(strictLocalize)];
    }
  };
};
var DAMAGE_ITEM_REPORT_INELIGIBLE = function DAMAGE_ITEM_REPORT_INELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INELIGIBLE_FOR_REPORT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [REQUEST_EXCEPTIONAL_EXTENSION(strictLocalize), DO_NOT_PROCESS_DAMAGED_AS_RETURN(strictLocalize)];
    }
  };
};
var REPORT_DAMAGED = function REPORT_DAMAGED(strictLocalize) {
  return strictLocalize({
    id: "mEIAJI",
    defaultMessage: [{
      "type": 0,
      "value": "Beschadigde, ontbrekende of onjuiste artikelen melden"
    }]
  });
};
var USE_BUTTON_TO_REPORT_DAMAGE = function USE_BUTTON_TO_REPORT_DAMAGE(strictLocalize) {
  return strictLocalize({
    id: "FNZNmK",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt melding maken van een beschadigd artikel met behulp van onderstaande knop."
    }]
  });
};
var REQUEST_EXCEPTIONAL_EXTENSION = function REQUEST_EXCEPTIONAL_EXTENSION(strictLocalize) {
  return strictLocalize({
    id: "EeVQrn",
    defaultMessage: [{
      "type": 0,
      "value": "Als er sprake is van uitzonderlijke omstandigheden kun je via onderstaande knop verlenging aanvragen."
    }]
  });
};